module.exports = __webpack_public_path__ + "static/img/cabecera.84db97a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/relaciones-institucionales-en/cabecera.jpg
// module id = FAKZ
// module chunks = 0